import { render, staticRenderFns } from "./tbp.vue?vue&type=template&id=3cbf117a&"
import script from "./tbp.vue?vue&type=script&lang=js&"
export * from "./tbp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports